// extracted by mini-css-extract-plugin
module.exports = {"tile":"NestedRow_tile__xGQgH","name":"NestedRow_name__TzL6A"};